import {
    Box,
    Button,
    Grid,
    GridItem,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import TextInput from "../formFields/TextInput.tsx";
import type {patientDetailsType} from "../../utils/typesConstant/types";
import {useUpdatePatientMutation} from "../../store/patientApi/patientApiSlice.ts";

interface AddPatientModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    patientDetails: patientDetailsType;
}

export default function AddPatientModal(props: AddPatientModalProps) {
    const [formData, setFormData] = useState<patientDetailsType>({
        uid: '',
        created_at: '',
        doctorName: '',
        doctor_id: '',
        gender: '',
        name: '',
        phone_number: '',
        updated_at: '',
        age: 0,
        patient_id: '',
    });

    const [updatePatient] = useUpdatePatientMutation();

    useEffect(() => {
        if (props.patientDetails) {
            setFormData(props.patientDetails);
        }
    }, [props.patientDetails]);

    const handleClose = () => {
        setFormData(props.patientDetails)
        props.setOpen(false);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries((formData as any).entries());
        const updatedPatientJson: patientDetailsType = {
            uid: props.patientDetails.uid,
            created_at: props.patientDetails.created_at,
            doctorName: formJson.doctorName,
            doctor_id: formJson.doctor_id,
            gender: formJson.gender,
            name: formJson.name,
            phone_number: formJson.phone_number,
            updated_at: props.patientDetails.updated_at,
            age: formJson.age,
            patient_id: props.patientDetails.patient_id,
        };

        console.log("Patient ID:", props.patientDetails.patient_id);
        console.log("Updated Patient JSON:", updatedPatientJson);
        await updatePatient({
            id: props.patientDetails.uid,
            body: updatedPatientJson,
        });

        // props.setOpen(false)
        handleClose()
    };
    return (
        <Modal isOpen={props.open} onClose={handleClose} size="xl">
            <ModalOverlay/>
            <ModalContent as="form" onSubmit={handleSubmit}>
                <ModalHeader>{props.patientDetails ? "Update Patient Details" : "Add New Patient"}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Box>

                        <Grid templateColumns="repeat(12, 1fr)" gap={4} mb={4}>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="name"
                                    label="Name"
                                    name="name"
                                    value={formData.name}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="age"
                                    label="Age"
                                    name="age"
                                    type='number'
                                    value={formData.age ? formData.age.toString() : ""}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                        </Grid>

                        <Grid templateColumns="repeat(12, 1fr)" gap={4} mb={4}>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="patient_id"
                                    label="Patient ID"
                                    name="patient_id"
                                    value={formData.patient_id}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                    isDisabled={true}
                                />
                            </GridItem>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="phone_number"
                                    label="Phone Number"
                                    name="phone_number"
                                    value={formData.phone_number}
                                    type='number'
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                        </Grid>

                        <Grid templateColumns="repeat(12, 1fr)" gap={4} mb={4}>
                            <GridItem colSpan={6}>
                                <TextInput
                                    id="gender"
                                    label="Gender"
                                    name="gender"
                                    value={formData.gender}
                                    formObject={formData}
                                    setFormObject={setFormData}
                                />
                            </GridItem>
                        </Grid>
                    </Box>
                </ModalBody>

                <ModalFooter>
                    <Button onClick={handleClose} mr={3}>
                        Cancel
                    </Button>
                    <Button type="submit" colorScheme="blue">
                        Submit
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
